export default __webpack_public_path__ + "static/media/cer13.aaeea199.png";